export const usePaymentSheetCleanup = (_isAuthenticated?: boolean) => {
  // Stub for web - no cleanup needed
};
